/**
 * "The workspace list changed": fired after a create, rename, move, archive / restore or membership
 * change succeeds, so screens that show the list outside the Settings page they were changed on (the
 * top-bar workspace switcher) load it again instead of showing the old names and nesting.
 */
const WORKSPACES_CHANGED = "inkfree:workspaces-changed";

export const notifyWorkspacesChanged = () => {
  window.dispatchEvent(new Event(WORKSPACES_CHANGED));
};

/** Calls `listener` on each change; returns the unsubscribe function (for a useEffect cleanup). */
export const onWorkspacesChanged = (listener: () => void) => {
  window.addEventListener(WORKSPACES_CHANGED, listener);
  return () => window.removeEventListener(WORKSPACES_CHANGED, listener);
};
